module.exports = __webpack_public_path__ + "static/media/icone_fleche_lirelasuite.6b3c24cc.svg";